import React, { useEffect, useState } from 'react';
import styles from './changePassword.module.scss';
import { useTranslation } from 'react-i18next';
import { SubmitHandler} from 'react-hook-form';

import { useNavigate } from 'react-router-dom';
import { PasportLayout } from 'src/components/PasportLayout/PasportLayout';
import { registrationApi } from './../../services/registerService';
import { IChangePassData } from 'types/common.types';
import { ChangePassForm } from 'src/components/Forms/ChangePassForm/ChangePassForm';
import { ErrorModal } from 'src/components/modals/ErrorModal/ErrorModal';
import { Button, Headline, Text } from 'forly-kit';
import { colors } from 'forly-kit/dist/colors';
import { IChangePassFormData } from 'src/components/Forms/ChangePassForm/changePassForm.types';

export const ChangePasswordPage: React.FC = () => {
	const {t, i18n} = useTranslation();
	const navigation = useNavigate();

	const [email, setEmail] = useState<string>('');
	const [pass, setPass] = useState<string>('');
	const [errorChange, setErrorChange] = useState<string>('');
	const [isSuccessChange, setIsSuccessChange] = useState<boolean>(false);

	const [
		changePass,
		{
			isLoading: changePassPending,
			isSuccess: changePassSuccess,
			error: changePassError
		} 
	] = registrationApi.useChangePassMutation();

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const email = params.get('email');
		const pass = params.get('pass');
		if (email && pass) {
			setEmail(email);
			setPass(pass);
		} else {
			navigation(`/${i18n.language}/auth/sign-up/`);
		}
	}, []);

	useEffect(() => {
		if (changePassSuccess) {
			setIsSuccessChange(true);
		}
	}, [changePassSuccess]);

	useEffect(() => {
		if (changePassError) {
			setErrorChange(t('errors.unknownError'));
		}
	}, [changePassError]);

	const goToPlatform = () => {
		location.href = `${CONFIG.lkUrl}/${i18n.language}/login/`;
	};

	const closeErrorModal = () => {
		setErrorChange('');
	};

	const onSubmit: SubmitHandler<IChangePassFormData> = async (data) => {
		const {password, confirmPassword} = data;
		
		const changeData: IChangePassData = {
			new_password_1: password,
			new_password_2: confirmPassword,
			username: email,
			password: pass
		};

		changePass(changeData);
	};


	return <>
		<PasportLayout >
			{isSuccessChange
				? <>
					<Headline 
						className={styles.title} 
						type='h0' 
						color={colors.primary800}
					>
						{t('successChangePass')}
					</Headline>
					<Text className={styles.subtitle} size='m'>{t('successChangePassSubtitle')}</Text>
					<Button
						variant='primary'
						text={t('goToLk')}
						onClick={goToPlatform}
					/>
				</> 
				: <ChangePassForm 
					action={onSubmit}
					isPending={changePassPending}
				/>}
		</PasportLayout>
		<ErrorModal 
			isOpen={!!errorChange}
			onClose={closeErrorModal}
			error={errorChange}
		/>
	</>;
};
